/**
 * Provider Form Page
 */

import { Truck } from 'lucide-react'
import { CatalogFormPage } from './CatalogFormPage'
import { useTranslation } from '@/hooks/useTranslation'

export function ProviderFormPage() {
  const { t } = useTranslation()

  return (
    <CatalogFormPage
      config={{
        endpoint: 'providers',
        basePath: '/providers',
        title: t('catalogs.providers'),
        newTitle: t('catalogs.newProvider'),
        editTitle: t('catalogs.editProvider'),
        icon: Truck,
        fields: [
          { key: 'name', label: t('catalogs.providerName'), type: 'text', required: true },
          {
            key: 'type_identification',
            label: t('clients.identificationType'),
            type: 'select',
            options: [
              { value: '01', label: t('idTypes.type01') },
              { value: '02', label: t('idTypes.type02') },
              { value: '03', label: t('idTypes.type03') },
              { value: '04', label: t('idTypes.type04') },
              { value: '05', label: t('idTypes.type05') },
            ],
          },
          { key: 'identification', label: t('clients.identification'), type: 'text' },
          { key: 'contact_name', label: t('catalogs.contactName'), type: 'text' },
          { key: 'email', label: t('clients.email'), type: 'email' },
          { key: 'phone', label: t('clients.phone'), type: 'tel' },
          { key: 'address', label: t('clients.address'), type: 'textarea' },
          { key: 'economic_activity', label: t('catalogs.economicActivity'), type: 'text' },
        ],
      }}
    />
  )
}
